export const DEBUG_EFFECT_EVENT = '2k48:debug-effect';

export type DebugEffect =
  'attack-8' | 'attack-64' | 'power-512' | 'power-1024' | 'power-2048' | 'hit' | 'ko';

export function emitDebugEffect(effect: DebugEffect): void {
  window.dispatchEvent(new CustomEvent<DebugEffect>(DEBUG_EFFECT_EVENT, { detail: effect }));
}

export function onDebugEffect(handler: (effect: DebugEffect) => void): () => void {
  const listener = (event: Event): void => handler((event as CustomEvent<DebugEffect>).detail);
  window.addEventListener(DEBUG_EFFECT_EVENT, listener);
  return () => window.removeEventListener(DEBUG_EFFECT_EVENT, listener);
}
